export default "__VITE_ASSET__805eb297__"